// Copyright (c) 2016 Deere & Company

import BatteryClaimContainer from '../../claim/battery/state-connector';

export default {
    component: BatteryClaimContainer,
    name: 'BATTERY',
    path: 'battery/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-battery-claim-route.js